var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-icon"},[_c('v-icon',{attrs:{"color":"primary","size":_vm.size}},[_vm._v("mdi-download")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }